<!--
* @Author: DY
* @Date: 2020-05-27 14:52:13
* @Description: '单方消耗'
-->
<template>
    <div class="unilateralConsumption">
        <div class="search-conditions-con">
            <div class="search-conditions">
                <span class="time-con" @click="selectDate">
                    <span>{{ date }}</span>
                </span>
                <span class="org" @click="showOrgPop=true">
                    <span class="org-name">{{ orgName }}</span>
                </span>
            </div>
        </div>

        <div class="main">
            <div class="split"></div>
            <div class="top">
                <div class="title">
                    <span class="van_right">
                        单位：(千克/方)
                    </span>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>原材料类型</th>
                            <th>配比用量</th>
                            <th>实际消耗</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            @click="selectRow(item, index)"
                            v-for="(item, index) in materialcategory"
                            :key="index"
                            :class="{'activeRow': activeRow === index}"
                        >
                            <td class="row-tit">
                                {{ item.material_category_name }}
                            </td>
                            <td>{{ item.theory_volume }}</td>
                            <td>{{ item.actual_value }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="split"></div>
            <div class="chart-con">
                <h4>按标号</h4>
                <template v-if="materialcategory.length>0">
                    <div
                        id="lineChart"
                        class="lineChart"
                    ></div>
                </template>
                <template v-else>
                    <h5>暂无数据</h5>
                </template>
            </div>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
        <van-popup v-model="showOrgPop" position="bottom" :style="{ height: '50%' }">
            <van-picker
                show-toolbar
                title="请选择"
                :columns="columns"
                @confirm="confirmOrg"
                @cancel="cancelOrg"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
import util from '@/utils/util';

export default {
    components: {},
    props: {},
    data() {
        return {
            // 选择时间
            showCalendarPop: false,
            // 选择组织结构
            showOrgPop: false,
            // 当前日期
            date: '',
            endTime: '',
            // 选中场站
            orgName: '全部',
            columns: [
                {
                    text: '全部',
                },
            ],
            // 场站
            stationData: [],
            // 选中场站code
            mixstation_code: '',
            currentDate: null,
            // 选中表格行index
            activeRow: 0,
            // 原料分类汇总数据
            materialcategory: [],
            // 选中原材料场站编码
            material_category_code: '',
            // 按标号统计
            gradeData: {
                xData: [],
                theory_volume: [],
                actual_value: [],
                consume: [],
            },
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        // 初始化页面
        init() {
            const date = new Date();
            this.date = util.timeFormat( date, 'yyyy-MM-01');
            this.currentDate = new Date(this.date);
            this.endTime = util.timeFormat( new Date(date.getFullYear(), date.getMonth() + 1), 'yyyy-MM-01');
            this.getStation();
            // 获取分类消耗汇总
            this.getClassifiedConsumptionSummary();
        },
        // 拉取场站
        async getStation() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        name: stationNames[index],
                    };
                });
                this.stationData = stationList;
                const columns = this.stationData.map(item => {
                    return { text: item.name };
                });
                this.columns.push(...columns);
            }
        },
        // 获取分类消耗汇总
        async getClassifiedConsumptionSummary() {
            await this.$axios
                .get('/interfaceApi/report/yclxh/get_consume_materiel?'
                    + `beginTime=${this.date} 00:00:00&`
                    + `endTime=${this.endTime} 00:00:00&`
                    + `station_id=${this.mixstation_code}`
                )
                .then(res => {
                    if (res && res.length > 0) {
                        this.materialcategory = res;
                        this.material_category_code = res[0].material_category_code;

                        // 按标号统计图
                        this.handleStatisticalstrengthgrade();
                    } else {
                        this.materialcategory = [];
                        this.material_category_code = '';
                    }
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 按标号
        async handleStatisticalstrengthgrade() {
            const res = await this.getStatisticalstrengthgrade();
            if (res) {
                this.gradeData = {
                    xData: [],
                    theory_volume: [],
                    actual_value: [],
                };
                res.map(item => {
                    this.gradeData.xData.push(item.strength_grade_name);
                    this.gradeData.theory_volume.push(item.theory_volume);
                    this.gradeData.actual_value.push(item.actual_value);
                });
                this.initGradeChart();
            }
        },
        // 按标号
        getStatisticalstrengthgrade() {
            const path = '/interfaceApi/report/yclxh/get_consume_label?'
                + `beginTime=${this.date} 00:00:00&`
                + `endTime=${this.endTime} 00:00:00&`
                + `station_id=${this.mixstation_code}&`
                + `material_category_code=${this.material_category_code}`;
            return this.$axios.$get(path, { defEx: true });
        },
        // 选择日期
        selectDate() {
            this.currentDate = new Date(this.date);
            this.showCalendarPop = true;
        },
        // 选中日期
        confirmDate(value) {
            this.showCalendarPop = false;
            this.date = util.timeFormat(value, 'yyyy-MM-01');
            this.endTime = util.timeFormat(new Date(value.setMonth(value.getMonth() + 1 )), 'yyyy-MM-01');
            // 获取分类消耗汇总
            this.getClassifiedConsumptionSummary();
        },
        // 取消选中日期
        cancelDate() {
            this.showCalendarPop = false;
        },
        // 场站确认选择
        confirmOrg(value) {
            this.showOrgPop = false;
            this.orgName = value.text;
            this.stationData.map(item => {
                if (item.name === value.text) {
                    this.mixstation_code = item.station_id;
                }
            });
            if (value.text === '全部') {
                this.mixstation_code = '';
            }
            // 获取分类消耗汇总
            this.getClassifiedConsumptionSummary();
        },
        // 场站取消选择
        cancelOrg() {
            this.showOrgPop = false;
        },
        // 选中table行
        selectRow(item, index) {
            this.material_category_code = item.material_category_code;
            this.activeRow = index;
            this.handleStatisticalstrengthgrade();
        },
        // 量价结构分析
        initGradeChart() {
            const myChart = this.$echarts.init(document.getElementById('lineChart'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                grid: {
                    left: 30,
                },
                legend: {
                    data: ['配比用量', '实际用量'],
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.gradeData.xData,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 12, // 字体大小
                            rotate: 30,
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '(吨)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '配比用量',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(113,198,176,1)', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(78,164,150,1)', // 100% 处的颜色
                            }], false),
                        },
                        barWidth: 10,
                        data: this.gradeData.theory_volume,
                    },
                    {
                        name: '实际用量',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(242,227,65,1)', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(220,193,41,1)', // 100% 处的颜色
                            }], false),
                        },
                        barWidth: 10,
                        data: this.gradeData.actual_value,
                    },
                ],
            };
            myChart.setOption(option, true);
        },
    },
};
</script>
<style lang="stylus" scoped>
.unilateralConsumption
    background #fff
    width 100%
    height 100%
    .search-conditions-con
        padding 10rpx
        .search-conditions
            font-size 16rpx
            height 45rpx
            box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
            border-radius 4rpx
            padding 10rpx 20rpx
            display flex
            justify-content space-around
            line-height 25rpx
            .time-con
                position relative
                flex 1
                text-align center
                &:after
                    content ''
                    position absolute
                    right 10rpx
                    height 15rpx
                    border-right 1px solid #D7D7D7
                    margin-top 5rpx
            .iconfont
                font-size 14rpx
                color #979EA7
                margin-left 5rpx
            .org
                flex 1
                text-align center
                .org-name
                    color #3495FB
    .main
        .top
            padding 10rpx
            .title
                height 16rpx
                overflow hidden
                margin-bottom 8rpx
                h4
                    font-size 16rpx
                    line-height 16rpx
                    color #333333
                span
                    font-size 12rpx
                    height 16rpx
                    line-height 16rpx
                    color #979EA7
            table
                width 100%
                border-spacing 0px
                border-collapse collapse
                table-layout fixed
                th
                    background rgba(235,240,252,1)
                    height 45rpx
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    font-size 14rpx
                    font-weight normal
                td
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    height 45rpx
                    text-align center
                    width 40rpx
                    font-size 14rpx
                    background rgba(85,136,241,.04)
                    width 25%
                    color #5588F1
                    &.row-tit
                        color #333333
                        background rgba(235,240,252,1)
                tbody
                    tr
                        &.activeRow
                            td
                                background rgba(250,132,54,1)
                                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                color #fff
                            .row-tit
                                color #823802
                                background rgba(245,242,237,1)
                                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                border 1px solid rgba(222,227,239,1)
        .split
            background #F0F0F0
            height 15rpx
        .chart-con
            padding 10rpx
            h4
                font-size 16rpx
            .lineChart
                width 95%
                margin-left 5%
                height 235rpx
            h5
                text-align center
                margin-top 20rpx
</style>
